<template>
  <div class="podcast-section-cover">
    <div v-if="loading" class="text-gray-600">
      Loading...
    </div>

    <div v-else>
      <FormSection class="col-1/2">
        <FormRow
          label="Logo"
          legend=""
          for-id="cover-logo-url"
          name="Logo"
          rules="required_if_empty:@cover-logo-text"
          ref="logoUrlRow"
        >
          <v-image-input
            v-model="modelData.logoUrl"
            id="cover-logo-url"
            name="cover-logo-url"
            :podcast-id="id"
            :acceptSvg="true"
          />
        </FormRow>

        <FormRow
          legend="oppure inserisci il testo alternativo al logo ( fino ad un massimo di
          30 caratteri )"
          for-id="cover-logo-text"
          name="Testo alternativo"
          rules="required_if_empty:@cover-logo-url|max:30"
          ref="logoTextRow"
        >
          <v-input
            type="text"
            v-model="modelData.logoText"
            id="cover-logo-text"
            name="cover-logo-text"
          />
        </FormRow>

        <FormRow
          label="Titolo"
          legend="(massimo 50 caratteri)"
          for-id="cover-title"
          name="Titolo"
          rules="required|max:50"
        >
          <v-input
            type="text"
            v-model="modelData.title"
            id="cover-title"
            name="cover-title"
          />
        </FormRow>

        <FormRow
          label="Sottotitolo"
          legend="(massimo 250 caratteri)"
          for-id="cover-subtitle"
          name="Sottotitolo"
          rules="html_max:250"
        >
          <v-medium-editor v-model="modelData.subtitle" id="cover-subtitle" />
        </FormRow>

        <FormRow
          label="Immagine"
          legend="(dimensioni suggerite 1500x2668 px)"
          for-id="cover-image-url"
          name="Immagine"
          rules="required"
        >
          <v-image-input
            v-model="modelData.imageUrl"
            id="cover-image-url"
            :podcast-id="id"
            :imageWidth="1500"
            :imageHeight="2668"
            label="Carica Immagine"
          />

          <div class="mt-2" />
          <v-image-input
            v-model="modelData.imageUrl"
            id="cover-image-url-gif"
            :podcast-id="id"
            :imageWidth="1"
            :imageHeight="1"
            :hide-image="true"
            label="Carica GIF animata"
          />
        </FormRow>

        <FormRow label="Black Layer" for-id="black-layer" name="black-layer">
          <CheckboxVue
            id="black-layer"
            name="black-layer"
            type="checkbox"
            v-model="checkGradient"
            :value="checkGradient"
          />
        </FormRow>

        <FormRow label="Autore" for-id="cover-author" name="Autore">
          <v-input
            type="text"
            v-model="modelData.author"
            id="cover-author"
            name="cover-author"
          />
        </FormRow>

        <FormRow
          label="Video"
          legend="(dimensioni suggerite 375x680px)"
          for-id="cover-video-url"
          name="Video"
        >
          <MuxUpload
            v-model="modelData.videoUrl"
            input-id="cover-video-url"
            clearable
          />
        </FormRow>
      </FormSection>
    </div>
  </div>
</template>

<script>
import CheckboxVue from '@/components/fields/CheckboxVue.vue'
import MuxUpload from '@/components/MuxUpload.vue'
import PodcastSectionBase from './PodcastSectionBase'
import GET_PODCAST_COVER from '@/graphql/GetPodcastCover.gql'
import UPDATE_PODCAST_COVER from '@/graphql/UpdatePodcastCover.gql'

export default {
  extends: PodcastSectionBase,

  components: {
    CheckboxVue,
    MuxUpload,
  },

  section: {
    query() {
      return {
        query: GET_PODCAST_COVER,
        variables: { podcastId: this.id },
      }
    },
    mutation() {
      return this.$apollo.mutate({
        mutation: UPDATE_PODCAST_COVER,
        variables: {
          id: this.id,
          cover: this.modelData,
        },
      })
    },
    model: {
      logoUrl: null,
      logoText: null,
      title: null,
      subtitle: null,
      imageUrl: null,
      hasGradient: true,
      author: null,
      videoUrl: null,
    },
    saveModel: data => ({ ...data.findPodcastByID.cover }),
  },

  computed: {
    checkGradient: {
      get() {
        return typeof this.modelData.hasGradient === 'boolean'
          ? this.modelData.hasGradient
          : true
      },
      set(checked) {
        this.modelData.hasGradient = !!checked
      },
    },
  },

  mounted() {
    this.unwatchValidation = this.$watch(
      'modelData',
      () => {
        if (this.modelData.logoUrl || this.modelData.logoText) {
          this.$refs.logoUrlRow.$refs.provider.validate()
          this.$refs.logoTextRow.$refs.provider.validate()
        }
      },
      {
        deep: true,
      },
    )
  },

  beforeDestroy() {
    this.$unwatchValidation && this.$unwatchValidation()
  },
}
</script>

<style lang="scss" scoped></style>
